const DEFAULT_SCENE = 'administration:data-import';
const UPLOAD_FILE = `${DEFAULT_SCENE}:upload-file`;
const TABLE = `${DEFAULT_SCENE}:table`;

export const getFieldsInputTag = (container: string) => (fieldName: string) => `${container}:input-${fieldName}`;

// DataImportScene
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;

// UploadFile
export const IMPORT_DATA_BUTTON_TAG = `${UPLOAD_FILE}:button-import`;
export const UPLOAD_FILE_SUBMIT_BUTTON_TAG = `${UPLOAD_FILE}:button-submit`;
export const UPLOAD_FILE_CANCEL_BUTTON_TAG = `${UPLOAD_FILE}:button-cancel`;
export const UPLOAD_FILE_NAME_TAG = `${UPLOAD_FILE}:file-name`;
export const UPLOAD_FILE_SIZE_TAG = `${UPLOAD_FILE}:file-size`;
export const getUploadFieldInputTag = getFieldsInputTag(UPLOAD_FILE);

// Imported Data Table
export const TABLE_TAG = TABLE;
export const TABLE_PAGINATION_TAG = `${TABLE}:pagination`;
export const TABLE_REFRESH_BUTTON_TAG = `${TABLE}:button-refresh`;
